<template>
  <div class="main">
    <my_menu></my_menu>

    <div class="content">
      <div class="search_box">
        <div class="time_picker_div">
          <Cascader :data="dep_options" v-model="select_dep" v-width="150" placeholder="选择部门" size="small"
            style="margin-right: 10px" @on-change="dep_change" />
          <Select v-model="project_id" filterable size="small" style="width: 250px" placeholder="请选择或搜索项目"
            @on-change="project_change" @on-clear="project_change" clearable>
            <Option v-for="item in project_options" :value="item.value" :key="item.value">{{ item.label }}
            </Option>
          </Select>
        </div>
        <div class="time_picker_div">
          <!--  -->
          <span>申请时间筛选：</span>
          <DatePicker size="small" type="date" placeholder="开始时间" style="width: 130px"
            @on-change="shenqing_start_time_change" @on-clear="shenqing_start_time_clear" />
          <span style="margin: 0 5px">-</span>
          <DatePicker size="small" type="date" placeholder="结束时间" style="width: 130px"
            @on-change="shenqing_end_time_change" @on-clear="shenqing_end_time_clear" />
        </div>
        <div class="time_picker_div">
          <!--  -->
          <span>发放时间筛选：</span>
          <DatePicker size="small" type="date" placeholder="开始时间" style="width: 130px"
            @on-change="fafang_start_time_change" @on-clear="fafang_start_time_clear" />
          <span style="margin: 0 5px">-</span>
          <DatePicker size="small" type="date" placeholder="结束时间" style="width: 130px"
            @on-change="fafang_end_time_change" @on-clear="fafang_end_time_clear" />
        </div>
        <div class="time_picker_div">
          <!--  -->
          <span>核销时间筛选：</span>
          <DatePicker size="small" type="date" placeholder="开始时间" style="width: 130px"
            @on-change="hexiao_start_time_change" @on-clear="hexiao_start_time_clear" />
          <span style="margin: 0 5px">-</span>
          <DatePicker size="small" type="date" placeholder="结束时间" style="width: 130px"
            @on-change="hexiao_end_time_change" @on-clear="hexiao_end_time_clear" />
        </div>
        <div>
          <Input v-model="search_name" size="small" placeholder="姓名筛选" @on-search="click_search_name" search
            enter-button style="width: 120px" />
        </div>
        <Button style="margin-left:10px" size="small" @click="export_btn">导出数据</Button>

      </div>
      <div class="tabs_pagemoney">
        <Tabs v-model="hexiao_status" @on-click="hexiaotab_click">
          <!-- <TabPane label="全部" name="0"></TabPane> -->
          <TabPane label="未核销" name="0"></TabPane>
          <TabPane label="已核销" name="1"></TabPane>
          <!-- <TabPane label="核销异常" name="2"></TabPane> -->

        </Tabs>
        <div class="fafang_div">
          <Checkbox v-model="hide_fafang_error"><span style="color:#888;font-size:13px">隐藏发放异常</span></Checkbox>

          <div class="pagemoney">本页合计金额：{{ page_money }}元</div>
        </div>

      </div>

      <div class="table_box">
        <Spin fix size="large" v-if="table_loading"></Spin>
        <Table size="small" :height="windowHeight - 190" border :columns="columns" :data="table_data">
          <template #hexiao_status="{ row }">
            <Tag v-if="row.is_hexiao == 0" color="warning">未核销</Tag>
            <Tag class="hexiao_tag" v-if="row.is_hexiao == 1" color="success" title="点击查看材料"
              @click="click_hexiao_cailiao(row)">已核销</Tag>
          </template>
          <template #is_fafang="{ row }">
            <Tag v-if="row.is_fafang == 0" color="warning">未发放</Tag>
            <Tag class="hexiao_tag" v-if="row.is_fafang == 1" color="success" @click="view_fafang_receipt(row)">已发放
            </Tag>
            <Tag v-if="row.is_fafang == 2" color="error">发放异常</Tag>
          </template>
          <template #affirm_hexiao_time="{ row }">
            <span class="">
              {{ row.affirm_hexiao_time }}</span>
          </template>
          <template #cailiao="{ row }">
            <span class="img_list" @click="click_img_list(row)">
              查看材料({{ row.img_list.length }})</span>
          </template>
          <template #action="{ row }">
            <div class="action_div">
              <div class="img_list" @click="click_jietu(row)">截图</div>
              <div class="img_list" style="margin-left: 5px" @click="click_affirm_hexiao(row)">
                核销
              </div>
            </div>
          </template>
        </Table>
        <div class="content_page">
          <Page show-total v-model="page" :total="total_count" :page-size="20" @on-change="page_change" />
        </div>
      </div>
    </div>

    <Modal v-model="jietu_show" title="借支单详情" :mask-closable="false" :footer-hide="true" width="500">
      <div class="jietu_box" ref="jiezhidan" id="jiezhidan">
        <div class="jiezhi_title">借支单</div>
        <div class="jiezhi_sqsj">申请时间：{{ jiezhidan_item.create_time }}</div>
        <div class="">
          <div class="jiezhi_box_field_flex">
            <div class="jiezhi_box_field">姓名：</div>
            <div>{{ jiezhidan_item.name }}</div>
          </div>
          <div class="jiezhi_box_field_flex">
            <div class="jiezhi_box_field">性别：</div>
            <div>{{ jiezhidan_item.gender }}</div>
          </div>
          <div class="jiezhi_box_field_flex">
            <div class="jiezhi_box_field">年龄：</div>
            <div>{{ jiezhidan_item.age }}岁</div>
          </div>
        </div>
        <div>身份证号：{{ jiezhidan_item.idcard }}</div>
        <div>手机号码：{{ jiezhidan_item.phone }}</div>
        <div>所属项目：{{ jiezhidan_item.project_name }}</div>
        <div>入职时间：{{ jiezhidan_item.entry_time }}</div>

        <div class="jiezhi_jine">
          <div>借支原因：{{ jiezhidan_item.cause }}</div>
          <div>借支金额：￥{{ jiezhidan_item.money }}</div>
          <div>开户银行：{{ jiezhidan_item.bank_of_deposit }}</div>
          <div>银行卡号：{{ jiezhidan_item.bank_card_number }}</div>
        </div>

        <div class="fafang_box">
          <div>发放时间：{{ jiezhidan_item.fafang_time }}</div>
          <div>核销时间：{{ jiezhidan_item.hexiao_time }}</div>
        </div>
      </div>
      <!-- <div class="jiezhidan_options">
                <Button size="small" @click="click_down_jiezhipic">下载图片</Button>

            </div> -->
    </Modal>

    <Modal v-model="affirm_hexiao_show" title="确认核销" :mask-closable="false" :footer-hide="true" width="500">
      <div class="upload_hexiao">
        <div>上传照片：</div>
        <Upload :action="upload_url" :on-success="success_change">
          <Button icon="ios-cloud-upload-outline">上传照片</Button>
        </Upload>
      </div>
      <div class="affirm_hexiao_btn">
        <Button type="primary" @click="click_affirm_hexiao_btn">确认核销</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import my_menu from "@/component/menu/menu.vue";
import { http, open_new_page, get_view_file_url } from "@/utils/http.js";
import html2canvas from "html2canvas";

export default {
  components: {
    my_menu,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      //系统列表
      table_data: [],
      columns: [],
      table_loading: false,
      search_name: "",
      page: 1,
      add_field_show: false,
      project_id: "",
      project_options: [],
      total_count: 0,
      shenqing_start_time: 0,
      shenqing_end_time: 0,
      fafang_start_time: 0,
      fafang_end_time: 0,
      hexiao_start_time: 0,
      hexiao_end_time: 0,
      jietu_show: false,
      jiezhidan_item: {},
      affirm_hexiao_show: false,
      hexiao_file: "",
      hexiao_item: {},
      hexiao_status: 0,
      upload_url:
        process.env.VUE_APP_HOST +
        "/data_panel/jiezhi/upload_hexiao?token=" +
        this.$cookies.get("dx_token"),
      dep_options: [],
      select_dep: [],
      page_money: 0,
      is_download: 0,
      hide_fafang_error:true
    };
  },

  mounted() {
    this.window_change();
    this.get_jiezhi_data();
    this.get_project_select_data();
    this.get_dep_data();
  },

  methods: {
    click_search_name() {
      this.page = 1;

      this.is_download = 0
      this.get_jiezhi_data();
    },

    export_btn() {
      this.is_download = 1
      this.page = 1;
      this.get_jiezhi_data();
    },

    get_dep_data() {
      var that = this;

      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/data_panel/jiezhi/dep_options", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.dep_options = res.data.dep_options;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    view_fafang_receipt(row) {
      this.$ImagePreview.show({
        previewList: [row.fafang_receipt],
      });
    },

    click_affirm_hexiao_btn() {
      var that = this;

      var obj = {
        jiezhi_id: this.hexiao_item.jiezhi_id,
        object_name: this.hexiao_file,
        resume_id: this.hexiao_item.resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/data_panel/jiezhi/affirm_hexiao",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.affirm_hexiao_show = false;
            that.get_jiezhi_data();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    success_change(e) {
      console.log(e);
      this.hexiao_file = e.data.img_object_name;
    },

    click_affirm_hexiao(row) {
      this.hexiao_item = row;
      this.affirm_hexiao_show = true;
    },

    click_jietu(item) {
      console.log(item);
      this.jietu_show = true;
      this.jiezhidan_item = item;
    },

    hexiao_end_time_clear() {
      this.hexiao_end_time = 0;
    },

    hexiao_end_time_change(e) {
      if (e) {
        var timeStamp = Date.parse(e);
      } else {
        var timeStamp = 0;
      }

      this.hexiao_end_time = timeStamp / 1000;
      this.page = 1;
      this.is_download = 0

      this.get_jiezhi_data();
    },

    hexiao_start_time_change(e) {
      if (e) {
        var timeStamp = Date.parse(e);
      } else {
        var timeStamp = 0;
      }

      console.log(timeStamp);
      this.hexiao_start_time = timeStamp / 1000;
      this.page = 1;
      this.is_download = 0

      this.get_jiezhi_data();
    },

    hexiao_start_time_clear(e) {
      this.hexiao_start_time = 0;
    },

    hexiao_end_time_clear() {
      this.hexiao_end_time = 0;
    },

    fafang_end_time_change(e) {
      if (e) {
        var timeStamp = Date.parse(e);
      } else {
        var timeStamp = 0;
      }

      this.fafang_end_time = timeStamp / 1000;
      this.page = 1;
      this.is_download = 0

      this.get_jiezhi_data();
    },

    fafang_start_time_change(e) {
      if (e) {
        var timeStamp = Date.parse(e);
      } else {
        var timeStamp = 0;
      }

      console.log(timeStamp);
      this.fafang_start_time = timeStamp / 1000;
      this.page = 1;
      this.is_download = 0

      this.get_jiezhi_data();
    },

    fafang_start_time_clear(e) {
      this.fafang_start_time = 0;
    },

    shenqing_end_time_clear() {
      this.shenqing_end_time = 0;
    },

    shenqing_end_time_change(e) {
      if (e) {
        var timeStamp = Date.parse(e);
      } else {
        var timeStamp = 0;
      }

      this.shenqing_end_time = timeStamp / 1000;
      this.page = 1;
      this.is_download = 0

      this.get_jiezhi_data();
    },

    shenqing_start_time_change(e) {
      if (e) {
        var timeStamp = Date.parse(e);
      } else {
        var timeStamp = 0;
      }

      console.log(timeStamp);
      this.shenqing_start_time = timeStamp / 1000;
      this.page = 1;
      this.is_download = 0

      this.get_jiezhi_data();
    },

    shenqing_start_time_clear(e) {
      this.shenqing_start_time = 0;
    },

    project_change() {
      this.is_download = 0

      this.page = 1;
      this.get_jiezhi_data();
    },

    page_change(e) {
      this.page = e;
      this.get_jiezhi_data();
    },

    //获取项目选择器数据
    get_project_select_data() {
      var that = this;

      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/data_panel/jiezhi/project_options",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.project_options = res.data.project_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    hexiaotab_click(e) {
      console.log(e);
      this.page = 1;
      this.get_jiezhi_data();
    },

    click_hexiao_cailiao(row) {
      var url_list = row.hexiao_img_list;
      this.$ImagePreview.show({
        previewList: url_list,
      });
    },

    dep_change() {
      this.is_download = 0
      this.page = 1;
      this.get_jiezhi_data();
    },

    //获取借支数据
    get_jiezhi_data() {
      var that = this;

      if (this.select_dep == null) {
        var dep_id = [];
      } else {
        var dep_id = this.select_dep;
      }

      var obj = {
        project_id: this.project_id,
        page: this.page,
        dep_id: dep_id,
        name: this.search_name,
        hexiao_status: Number(this.hexiao_status),
        shenqing_start_time: this.shenqing_start_time,
        shenqing_end_time: this.shenqing_end_time,
        fafang_start_time: this.fafang_start_time,
        fafang_end_time: this.fafang_end_time,
        hexiao_start_time: this.hexiao_start_time,
        hexiao_end_time: this.hexiao_end_time,
        is_download: this.is_download,
        hide_fafang_error:this.hide_fafang_error
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/data_panel/jiezhi/jiezhi_data", obj, true)
        .then((res) => {
          if (res.code == 0) {

            if (res.data.object_name.length > 10) {
              that.$Modal.confirm({
                title: '提示',
                content: '<p>数据导出成功，是否查看？</p>',
                onOk: () => {
                  get_view_file_url(res.data.object_name)
                },
                onCancel: () => {
                }
              });
            } else {
              that.table_data = res.data.table_data;
              that.columns = res.data.columns;
              that.total_count = res.data.total_count;
              that.page_money = res.data.page_money;
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },

    click_img_list(row) {
      var url_list = row.img_list;
      this.$ImagePreview.show({
        previewList: url_list,
      });
    },



    click_down_jiezhipic() {
      let template = document.querySelector("#jiezhidan");
      html2canvas(template, {
        scale: 4, // 放大倍数 越大越清晰 文件越大
      }).then((canvas) => {
        let imgDataSrc = canvas.toDataURL("image/png", 1.0);
        let name = "图片名称";
        const $tag = document.createElement("a");
        $tag.setAttribute("download", name.replace(/\./g, "。"));
        $tag.href = imgDataSrc;
        $tag.click();
      });
    },

    click_hexiao(item) {
      console.log(item);
    },
  },
};
</script>

<style scoped>
.fafang_div{
  display: flex;
  align-items: center;
}

.pagemoney {
  font-size: 13px;
  color: #818181;
}

.tabs_pagemoney {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hexiao_tag {
  cursor: pointer;
}

.affirm_hexiao_btn {
  display: flex;
  justify-content: flex-end;
}

.upload_hexiao {
  display: flex;
  align-items: center;
}

.action_div {
  display: flex;
  align-items: center;
}

.fafang_box {
  border-top: 1px dashed #ccc;
  margin-top: 10px;
  padding-top: 10px;
}

.jiezhidan_options {
  margin-top: 20px;
  text-align: right;
}

.jiezhi_jine {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #ccc;
  font-weight: 600;
}

.jiezhi_name {
  display: flex;
  align-items: center;
}

.jiezhi_sqsj {
  text-align: right;
  font-size: 13px;
  color: #ccc;
}

.jiezhi_title {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  padding-bottom: 10px;
  color: #000;
  border-bottom: 1px solid #ccc;
}

.jiezhi_box_field_flex {
  display: flex;
  align-items: center;
}

.jiezhi_box_field {
  width: 70px;
  flex-shrink: 0;
}

.jietu_box {
  padding: 10px;
  width: 460px;
  border: 3px solid #222222;
}

.search_box {
  display: flex;
  flex-wrap: wrap;
}

.time_picker_div {
  display: flex;
  align-items: center;
  margin: 0px 10px 10px 10px;
}

.img_list {
  cursor: pointer;
  color: #4a5fab;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
  margin-top: 10px;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  width: calc(100% - 180px);
  background-color: #fff;
  position: absolute;
  right: 0px;
  top: 0px;
  height: 100vh;
  padding: 10px;
}

.main {
  background: #f5f7f9;
  min-height: 100vh;
}
</style>
